import { jsx as p, jsxs as S, Fragment as K } from "react/jsx-runtime";
import { DismissableLayer as U } from "@radix-ui/react-dismissable-layer";
import * as W from "@radix-ui/react-portal";
import { useControllableState as J } from "@radix-ui/react-use-controllable-state";
import * as Z from "@radix-ui/react-visually-hidden";
import { Button as E } from "@telegraph/button";
import { useComposedRefs as j } from "@telegraph/compose-refs";
import { RefToTgphRef as ee } from "@telegraph/helpers";
import { Lucide as R, Icon as N } from "@telegraph/icon";
import { Input as te } from "@telegraph/input";
import { Stack as I, Box as _ } from "@telegraph/layout";
import { Menu as Q } from "@telegraph/menu";
import { motion as B, AnimatePresence as P } from "@telegraph/motion";
import { Tag as L } from "@telegraph/tag";
import { Tooltip as oe } from "@telegraph/tooltip";
import { Text as M } from "@telegraph/typography";
import i from "react";
const ne = {
  0: "5",
  1: "6",
  2: "8",
  3: "10"
}, k = (t) => Array.isArray(t), T = (t) => typeof t == "object" && !Array.isArray(t) || typeof t == "string" || !t, re = (t) => {
  const a = (r, c = []) => (i.Children.toArray(r).forEach((n) => {
    i.isValidElement(n) && (n.props.value ? c.push(n) : n.props.children && a(n.props.children, c));
  }), c);
  return a(t).map((r) => {
    var o;
    const c = r;
    return {
      value: c.props.value,
      label: ((o = c.props) == null ? void 0 : o.label) || c.props.children || c.props.value
    };
  });
}, C = (t, a) => {
  if (t)
    return a === !0 ? t == null ? void 0 : t.value : t;
}, F = (t, a, e) => {
  if (!t || !a || a.length === 0) return;
  const l = a.find(
    (r) => r.value === C(t, e)
  );
  if (l)
    return l;
}, ae = ({
  children: t,
  value: a,
  searchQuery: e
}) => {
  const l = $(t);
  return (a == null ? void 0 : a.toLowerCase().includes(e.toLowerCase())) || l.some(
    (r) => r.toLowerCase().includes(e.toLowerCase())
  );
}, $ = (t) => {
  const a = i.Children.toArray(t), e = [];
  return a.forEach((l) => {
    typeof l == "string" && e.push(l), i.isValidElement(l) && l.props.children && e.push(...$(l.props.children));
  }), e;
}, ie = ["ArrowDown", "PageUp", "Home"], ce = ["ArrowUp", "PageDown", "End"], z = ["Enter", " "], x = i.createContext({
  value: void 0,
  onValueChange: () => {
  },
  contentId: "",
  triggerId: "",
  open: !1,
  setOpen: () => {
  },
  onOpenToggle: () => {
  },
  clearable: !1,
  disabled: !1,
  options: [],
  legacyBehavior: !1
}), se = ({
  modal: t = !0,
  closeOnSelect: a = !0,
  clearable: e = !1,
  disabled: l = !1,
  legacyBehavior: r = !1,
  open: c,
  onOpenChange: o,
  defaultOpen: n,
  value: s,
  onValueChange: f,
  errored: y,
  placeholder: v,
  layout: d,
  children: u,
  ...g
}) => {
  const m = i.useId(), b = i.useId(), h = i.useRef(null), w = i.useRef(null), V = i.useRef(null), D = i.useMemo(() => re(u), [u]), [Y, H] = i.useState(""), [O = !1, A] = J({
    prop: c,
    defaultProp: n,
    onChange: o
  }), X = i.useCallback(() => {
    A((q) => !q);
  }, [A]);
  return i.useEffect(() => {
    O || H("");
  }, [O]), /* @__PURE__ */ p(
    x.Provider,
    {
      value: {
        contentId: m,
        triggerId: b,
        value: s,
        // Need to cast this to avoid type errors
        // because the type of onValueChange is not
        // consistent with the value type
        onValueChange: f,
        placeholder: v,
        open: O,
        setOpen: A,
        onOpenToggle: X,
        closeOnSelect: a,
        clearable: e,
        disabled: l,
        searchQuery: Y,
        setSearchQuery: H,
        triggerRef: h,
        searchRef: w,
        contentRef: V,
        errored: y,
        layout: d,
        options: D,
        legacyBehavior: r
      },
      children: /* @__PURE__ */ p(
        Q.Root,
        {
          open: O,
          onOpenChange: A,
          modal: t,
          ...g,
          children: u
        }
      )
    }
  );
}, le = ({ value: t, ...a }) => {
  const e = i.useContext(x), l = i.useMemo(() => {
    const r = e.options.find((n) => n.value === t);
    if (r) return r.label || r.value;
    if (!e.value) return;
    const o = e.value.find(
      (n) => C(n, e.legacyBehavior) === t
    );
    if (o)
      return o;
  }, [e.options, e.value, t, e.legacyBehavior]);
  return /* @__PURE__ */ S(
    L.Root,
    {
      as: B.span,
      initializeWithAnimation: !1,
      initial: { opacity: 0, scale: 0.5 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.5 },
      transition: { duration: 100, type: "spring" },
      "tgph-motion-key": t,
      size: "1",
      layout: "position",
      ...a,
      children: [
        /* @__PURE__ */ p(L.Text, { children: l }),
        /* @__PURE__ */ p(
          L.Button,
          {
            icon: { icon: R.X, alt: `Remove ${t}` },
            onClick: (r) => {
              if (!e.onValueChange) return;
              const c = e.onValueChange, n = e.value.filter((s) => C(s, e.legacyBehavior) !== t);
              c == null || c(n), r.stopPropagation(), r.preventDefault();
            }
          }
        )
      ]
    }
  );
}, ue = () => {
  var a;
  const t = i.useContext(x);
  if (t.value && k(t.value)) {
    const e = t.layout || "truncate", l = t.value.length - 2, r = l.toString().split("");
    return t.value.length === 0 ? /* @__PURE__ */ p(E.Text, { color: "gray", children: t.placeholder }) : /* @__PURE__ */ S(
      I,
      {
        gap: "1",
        w: "full",
        wrap: e === "wrap" ? "wrap" : "nowrap",
        align: "center",
        style: {
          position: "relative",
          flexGrow: 1
        },
        children: [
          /* @__PURE__ */ p(
            P,
            {
              presenceMap: t.value.map((c) => ({
                "tgph-motion-key": C(c, t.legacyBehavior) || "",
                value: !0
              })),
              children: t.value.map((c, o) => {
                const n = C(c, t.legacyBehavior);
                if (n && (e === "truncate" && o <= 1 || e === "wrap"))
                  return /* @__PURE__ */ p(ee, { children: /* @__PURE__ */ p(le, { value: n }) }, n);
              })
            }
          ),
          /* @__PURE__ */ p(
            P,
            {
              presenceMap: [
                {
                  "tgph-motion-key": "combobox-more",
                  value: !0
                }
              ],
              children: e === "truncate" && t.value.length > 2 && /* @__PURE__ */ p(
                I,
                {
                  as: B.div,
                  initial: { opacity: 0 },
                  animate: { opacity: 1 },
                  exit: { opacity: 0 },
                  transition: { duration: 100, type: "spring" },
                  h: "full",
                  pr: "1",
                  pl: "8",
                  align: "center",
                  "aria-label": `${l} more selected`,
                  position: "absolute",
                  right: "0",
                  style: {
                    backgroundImage: "linear-gradient(to left, var(--tgph-surface-1) 0 60%, transparent 90% 100%)"
                  },
                  children: /* @__PURE__ */ S(M, { as: "span", size: "1", style: { whiteSpace: "nowrap" }, children: [
                    "+",
                    /* @__PURE__ */ S(
                      P,
                      {
                        presenceMap: r.map((c) => ({
                          "tgph-motion-key": c,
                          value: !0
                        })),
                        children: [
                          r.map((c) => /* @__PURE__ */ p(
                            _,
                            {
                              as: B.span,
                              initial: { opacity: 0 },
                              animate: { opacity: 1 },
                              exit: { opacity: 0 },
                              transition: { duration: 100, type: "spring" },
                              w: "2",
                              display: "inline-block",
                              "tgph-motion-key": c,
                              children: c
                            },
                            c
                          )),
                          " "
                        ]
                      }
                    ),
                    "more"
                  ] })
                }
              )
            }
          )
        ]
      }
    );
  }
  if (t && T(t.value)) {
    const e = F(
      t.value,
      t.options,
      t.legacyBehavior
    ), l = (e == null ? void 0 : e.label) || (e == null ? void 0 : e.value) || t.placeholder, r = t.legacyBehavior && ((a = t == null ? void 0 : t.value) == null ? void 0 : a.label);
    return /* @__PURE__ */ p(
      E.Text,
      {
        color: t.value ? "default" : "gray",
        textOverflow: "ellipsis",
        overflow: "hidden",
        children: r || l
      }
    );
  }
}, pe = ({ size: t = "2", ...a }) => {
  const e = i.useContext(x), l = i.useCallback(() => {
    var o;
    if (!e.value) return e.placeholder;
    if (T(e.value)) {
      const n = F(
        e.value,
        e.options,
        e.legacyBehavior
      );
      return (n == null ? void 0 : n.label) || e.placeholder;
    }
    if (k(e.value))
      return ((o = e.value) == null ? void 0 : o.map((n) => {
        const s = F(
          n,
          e.options,
          e.legacyBehavior
        );
        return s == null ? void 0 : s.label;
      }).join(", ")) || e.placeholder;
  }, [
    e.value,
    e.placeholder,
    e.options,
    e.legacyBehavior
  ]), r = i.useMemo(() => {
    var o;
    if (T(e.value))
      return e.clearable && e.value;
    if (k(e.value))
      return e.clearable && ((o = e.value) == null ? void 0 : o.length) > 0;
  }, [e.clearable, e.value]), c = () => {
    var o, n;
    if (k(e.value)) {
      const s = e.onValueChange;
      s == null || s([]);
    }
    if (T(e.value)) {
      const s = e.onValueChange;
      s == null || s(void 0);
    }
    (n = (o = e.triggerRef) == null ? void 0 : o.current) == null || n.focus();
  };
  return /* @__PURE__ */ p(
    Q.Trigger,
    {
      ...a,
      asChild: !0,
      onClick: (o) => {
        var n, s;
        o.preventDefault(), e.onOpenToggle(), (s = (n = e.triggerRef) == null ? void 0 : n.current) == null || s.focus();
      },
      onKeyDown: (o) => {
        if (o.key === "Tab") {
          o.stopPropagation();
          return;
        }
        if (z.includes(o.key)) {
          o.preventDefault();
          return;
        }
        if (o.key === "ArrowDown") {
          o.stopPropagation(), o.preventDefault(), e.onOpenToggle();
          return;
        }
      },
      tgphRef: e.triggerRef,
      children: /* @__PURE__ */ S(
        E.Root,
        {
          id: e.triggerId,
          type: "button",
          bg: "surface-1",
          variant: "outline",
          align: "center",
          minH: ne[t],
          h: "full",
          w: "full",
          py: "1",
          size: t,
          color: e.errored ? "red" : "gray",
          justify: "space-between",
          role: "combobox",
          "aria-label": l(),
          "aria-controls": e.contentId,
          "aria-expanded": e.open,
          "aria-haspopup": "listbox",
          "data-tgph-combobox-trigger": !0,
          "data-tgph-combobox-trigger-open": e.open,
          disabled: e.disabled,
          children: [
            /* @__PURE__ */ p(ue, {}),
            /* @__PURE__ */ S(I, { align: "center", gap: "1", children: [
              r && /* @__PURE__ */ p(oe, { label: "Clear field", children: /* @__PURE__ */ p(
                E,
                {
                  type: "button",
                  icon: { icon: R.X, alt: "Clear field" },
                  size: "1",
                  variant: "ghost",
                  onClick: (o) => {
                    e.value && (o.stopPropagation(), c());
                  },
                  onKeyDown: (o) => {
                    (o.key === "Enter" || o.key === " ") && (o.stopPropagation(), c());
                  },
                  "data-tgph-combobox-clear": !0,
                  style: {
                    // Remove margin to make the clear button flush
                    // with the trigger button
                    marginTop: "calc(-1 * var(--tgph-spacing-1)",
                    marginBottom: "calc(-1 * var(--tgph-spacing-1)"
                  }
                }
              ) }),
              /* @__PURE__ */ p(
                E.Icon,
                {
                  as: B.span,
                  animate: { rotate: e.open ? 180 : 0 },
                  transition: { duration: 150, type: "spring" },
                  icon: R.ChevronDown,
                  "aria-hidden": !0
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, fe = ({
  style: t,
  children: a,
  tgphRef: e,
  ...l
}) => {
  const r = i.useContext(x), c = i.useRef(!1), o = j(e, r.contentRef), n = i.useRef(null), [s, f] = i.useState(0), [y, v] = i.useState(!1), d = i.useCallback(
    (u) => {
      const g = u == null ? void 0 : u.getBoundingClientRect();
      g && f(g.height), y || v(!0);
    },
    [y]
  );
  return i.useEffect(() => {
    const u = new ResizeObserver((g) => {
      for (const m of g) {
        const b = m.target;
        d(b);
      }
    });
    return n.current && y && u.observe(n.current), () => u.disconnect();
  }, [y, d]), i.useEffect(() => {
    y === !0 && r.open === !1 && v(!1);
  }, [r.open, y]), i.useEffect(() => {
    let u;
    return r.open && (u = setTimeout(() => {
      d(n.current);
    }, 10)), () => u && clearTimeout(u);
  }, [r.open, d]), /* @__PURE__ */ p(W.Root, { asChild: !0, children: /* @__PURE__ */ p(
    U,
    {
      onEscapeKeyDown: (u) => {
        r.open && (u.stopPropagation(), u.preventDefault(), r.setOpen(!1));
      },
      children: /* @__PURE__ */ p(
        Q.Content,
        {
          className: "tgph",
          mt: "1",
          onCloseAutoFocus: (u) => {
            var g, m;
            c.current || (m = (g = r.triggerRef) == null ? void 0 : g.current) == null || m.focus(), c.current = !1, u.preventDefault();
          },
          bg: "surface-1",
          style: {
            width: "var(--tgph-combobox-trigger-width)",
            transition: "min-height 200ms ease-in-out",
            minHeight: s ? `${s}px` : "0",
            ...t,
            "--tgph-combobox-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--tgph-combobox-content-available-width": "var(--radix-popper-available-width)",
            "--tgph-combobox-content-available-height": "calc(var(--radix-popper-available-height) - var(--tgph-spacing-8))",
            "--tgph-combobox-trigger-width": "var(--radix-popper-anchor-width)",
            "--tgph-combobox-trigger-height": "var(--radix-popper-anchor-height)"
          },
          ...l,
          tgphRef: o,
          "data-tgph-combobox-content": !0,
          "data-tgph-combobox-content-open": r.open,
          role: void 0,
          "aria-orientation": void 0,
          onKeyDown: (u) => {
            var m, b, h, w;
            u.stopPropagation();
            const g = (b = (m = r.contentRef) == null ? void 0 : m.current) == null ? void 0 : b.querySelectorAll(
              "[data-tgph-combobox-option]"
            );
            document.activeElement === (g == null ? void 0 : g[0]) && ce.includes(u.key) && ((w = (h = r.searchRef) == null ? void 0 : h.current) == null || w.focus());
          },
          children: /* @__PURE__ */ p(I, { direction: "column", gap: "1", tgphRef: n, children: a })
        }
      )
    }
  ) });
}, ge = ({ ...t }) => {
  const a = i.useContext(x);
  return /* @__PURE__ */ p(
    I,
    {
      id: a.contentId,
      direction: "column",
      gap: "1",
      style: {
        overflowY: "auto",
        // maxHeight defaults to available height - padding from edge of screen
        "--max-height": t.maxHeight ? void 0 : "calc(var(--tgph-combobox-content-available-height) - var(--tgph-spacing-12))"
      },
      role: "listbox",
      ...t
    }
  );
}, G = ({
  value: t,
  label: a,
  selected: e,
  onSelect: l,
  children: r,
  ...c
}) => {
  const o = i.useContext(x), [n, s] = i.useState(!1), f = o.value, y = !o.searchQuery || ae({
    children: a || r,
    value: t,
    searchQuery: o.searchQuery
  }), v = k(f) ? f.some(
    (u) => C(u, o.legacyBehavior) === t
  ) : C(f, o.legacyBehavior) === t, d = (u) => {
    var m, b;
    u.stopPropagation();
    const g = u;
    if (!(g.key && !z.includes(g.key))) {
      if (u.preventDefault(), o.closeOnSelect === !0 && o.setOpen(!1), l)
        return l(u);
      if (T(f)) {
        const h = o.onValueChange;
        o.legacyBehavior === !0 ? h == null || h({ value: t, label: a }) : h == null || h(t);
      } else if (k(f)) {
        const h = o.onValueChange, w = o.value, V = v ? w.filter(
          (D) => C(D, o.legacyBehavior) !== t
        ) : [
          ...w,
          // TODO: Remove this once { value, label } option is deprecated
          o.legacyBehavior === !0 ? { value: t, label: a } : t
        ];
        h == null || h(V);
      }
      (b = (m = o.triggerRef) == null ? void 0 : m.current) == null || b.focus();
    }
  };
  if (y)
    return /* @__PURE__ */ p(
      Q.Button,
      {
        type: "button",
        onSelect: d,
        onKeyDown: d,
        selected: e === null ? null : e ?? v,
        onFocus: () => s(!0),
        onBlur: () => s(!1),
        role: "option",
        "aria-selected": v ? "true" : "false",
        "data-tgph-combobox-option": !0,
        "data-tgph-combobox-option-focused": n,
        "data-tgph-combobox-option-value": t,
        "data-tgph-combobox-option-label": a,
        ...c,
        children: a || r || t
      }
    );
}, he = ({
  label: t = "Search",
  placeholder: a = "Search",
  tgphRef: e,
  value: l,
  onValueChange: r,
  ...c
}) => {
  var v;
  const o = i.useId(), n = i.useContext(x), s = j(e, n.searchRef), f = l ?? n.searchQuery, y = r ?? n.setSearchQuery;
  return i.useEffect(() => {
    var g;
    const d = (m) => {
      var b, h;
      ie.includes(m.key) && ((h = (b = n.contentRef) == null ? void 0 : b.current) == null || h.focus({ preventScroll: !0 })), m.key === "Escape" && n.setOpen(!1), m.stopPropagation();
    }, u = (g = n.searchRef) == null ? void 0 : g.current;
    if (u)
      return u.addEventListener("keydown", d), () => {
        u.removeEventListener("keydown", d);
      };
  }, [n]), /* @__PURE__ */ S(_, { borderBottom: "px", px: "1", pb: "1", children: [
    /* @__PURE__ */ p(Z.Root, { children: /* @__PURE__ */ p(M, { as: "label", htmlFor: o, children: t }) }),
    /* @__PURE__ */ p(
      te,
      {
        id: o,
        variant: "ghost",
        placeholder: a,
        value: f,
        onChange: (d) => {
          y(d.target.value);
        },
        LeadingComponent: /* @__PURE__ */ p(N, { icon: R.Search, alt: "Search Icon" }),
        TrailingComponent: n != null && n.searchQuery && ((v = n == null ? void 0 : n.searchQuery) == null ? void 0 : v.length) > 0 ? /* @__PURE__ */ p(
          E,
          {
            variant: "ghost",
            color: "gray",
            icon: { icon: R.X, alt: "Clear Search Query" },
            onClick: () => {
              var d;
              return (d = n.setSearchQuery) == null ? void 0 : d.call(n, "");
            }
          }
        ) : null,
        autoFocus: !0,
        "data-tgph-combobox-search": !0,
        "aria-controls": n.contentId,
        ...c,
        tgphRef: s
      }
    )
  ] });
}, de = ({
  icon: t = { icon: R.Search, alt: "Search Icon" },
  message: a = "No results found",
  children: e,
  ...l
}) => {
  const r = i.useContext(x), [c, o] = i.useState(!1);
  if (i.useEffect(() => {
    var s, f;
    const n = (f = (s = r.contentRef) == null ? void 0 : s.current) == null ? void 0 : f.querySelectorAll(
      "[data-tgph-combobox-option]"
    );
    (n == null ? void 0 : n.length) === 0 ? o(!0) : o(!1);
  }, [r.searchQuery, r.contentRef, e]), c)
    return /* @__PURE__ */ S(
      I,
      {
        gap: "1",
        align: "center",
        justify: "center",
        w: "full",
        my: "8",
        "data-tgph-combobox-empty": !0,
        ...l,
        children: [
          t === null ? /* @__PURE__ */ p(K, {}) : /* @__PURE__ */ p(N, { ...t }),
          a === null ? /* @__PURE__ */ p(K, {}) : /* @__PURE__ */ p(M, { as: "span", children: a })
        ]
      }
    );
}, me = ({
  leadingText: t = "Create",
  values: a,
  onCreate: e,
  selected: l = null,
  legacyBehavior: r = !1,
  ...c
}) => {
  const o = i.useContext(x), n = i.useCallback(
    (s) => !a || (a == null ? void 0 : a.length) === 0 ? !1 : a.some(
      (f) => C(f, r) === s
    ),
    [a, r]
  );
  if (o.searchQuery && !n(o.searchQuery))
    return /* @__PURE__ */ p(
      G,
      {
        leadingIcon: { icon: R.Plus, "aria-hidden": !0 },
        mx: "1",
        value: o.searchQuery,
        label: `${t} "${o.searchQuery}"`,
        selected: l,
        onSelect: () => {
          var s;
          if (e && o.value && o.searchQuery) {
            const f = r === !0 ? { value: o.searchQuery } : o.searchQuery;
            e(f), (s = o.setSearchQuery) == null || s.call(o, "");
          }
        },
        ...c
      }
    );
}, ye = {};
Object.assign(ye, {
  Root: se,
  Trigger: pe,
  Content: fe,
  Options: ge,
  Option: G,
  Search: he,
  Empty: de,
  Create: me
});
export {
  ye as Combobox
};
//# sourceMappingURL=index.mjs.map
